import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M14.8 16.8H1.2V2.2h9.788l1.2-1.2H0v17h16V6.812l-1.2 1.2V16.8zm2.708-15.568l-.74-.74A1.675 1.675 0 0 0 15.58 0c-.43 0-.86.164-1.188.492L6.298 8.587 4 14l5.413-2.298 8.095-8.095a1.68 1.68 0 0 0 0-2.375zm-.849 1.527l-7.93 7.93-2.464 1.046 1.046-2.464 7.93-7.93a.477.477 0 0 1 .678 0l.74.74a.477.477 0 0 1 0 .678z" />
  </svg>
);

export default SvgComponent;
